module.exports = __webpack_public_path__ + "static/media/app-section.6609cf69.png";